module.exports = __webpack_public_path__ + "img/five4Green.ebcae204.jpg";